/* Adds restrained policy information to the existing custom storefront. */
(() => {
  const link = '/policies/refund-policy#digital-products';
  const catalog = window.__DSS_POLICY_CATALOG__ || {};
  const digitalIds = new Set(Object.values(catalog).flatMap(p => (p.variants || []).filter(v => v.requires_shipping === false).map(v => String(v.id))));
  let scheduled = false;
  function digitalPurchase() {
    const match = location.pathname.match(/^\/products\/([^/]+)/);
    if (match) return (catalog[decodeURIComponent(match[1])]?.variants || []).some(v => v.requires_shipping === false);
    if (location.pathname.replace(/\/$/, '') === '/cart') {
      try { const cart = JSON.parse(localStorage.getItem('dss-prototype-cart') || '[]'); return Array.isArray(cart) && cart.some(x => digitalIds.has(String(x.variantId))); } catch { return false; }
    }
    return false;
  }
  function sync() {
    scheduled = false;
    const footer = document.querySelector('.site-footer nav[aria-label="Store policies"]');
    if (footer && !footer.querySelector('[data-digital-policy-link]')) {
      const a = document.createElement('a'); a.href = link; a.textContent = 'Digital purchase policy'; a.dataset.digitalPolicyLink = ''; footer.append(a);
    }
    const host = document.querySelector('.purchase-actions') || document.querySelector('.cart-layout > aside');
    if (!host) return;
    let notice = host.querySelector('[data-store-digital-policy]');
    if (!digitalPurchase()) { if (notice) notice.remove(); return; }
    if (!notice) {
      notice = document.createElement('div'); notice.dataset.storeDigitalPolicy = '';
      notice.style.cssText = 'grid-column:1/-1;font-size:14px;line-height:1.5;margin:12px 0';
      const p = document.createElement('p'); p.textContent = 'Digital purchase—not a trial. No change-of-mind refunds. The Dispatcher is beta software and bugs may occur. ';
      const label = document.createElement('label'); label.style.cssText = 'display:flex;align-items:flex-start;gap:10px';
      const checkbox = document.createElement('input'); checkbox.type = 'checkbox'; checkbox.dataset.storePolicyConsent = ''; checkbox.required = true; checkbox.style.cssText = 'width:18px;height:18px;flex:none;margin-top:3px';
      label.append(checkbox, document.createTextNode('I have read and agree to the digital purchase terms.'));
      const error = document.createElement('p'); error.dataset.storePolicyError = ''; error.setAttribute('role', 'alert');
      checkbox.addEventListener('change', () => { error.textContent = ''; });
      notice.append(p, label, error);
      const buy = host.querySelector('.buy-now-button, a[href*="/cart/"]');
      host.insertBefore(notice, buy || host.firstChild);
    }
  }
  // Capture before React's checkout handler; hardware-only purchases are unaffected.
  document.addEventListener('click', event => {
    const control = event.target.closest?.('.buy-now-button,.shop-pay-button,.cart-layout > aside a[href*="/cart/"]');
    if (!control || !digitalPurchase()) return;
    sync();
    const consent = document.querySelector('[data-store-policy-consent]');
    if (!consent?.checked) {
      event.preventDefault(); event.stopImmediatePropagation();
      const error = document.querySelector('[data-store-policy-error]');
      if (error) error.textContent = 'Please read and accept the digital purchase terms before continuing.';
      consent?.focus();
    }
  }, true);
  const root = document.getElementById('root');
  if (root) new MutationObserver(() => { if (!scheduled) { scheduled = true; queueMicrotask(sync); } }).observe(root, {childList:true,subtree:true});
  window.addEventListener('dss-cart-change', sync);
  sync();
})();
